<template>
    <div class="headline-box">
        <RichText v-if="title" :data="title"></RichText>
    </div>
</template>
<script>
import RichText from '@/views/components/RichText.vue'
export default {
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    components: { RichText }
}
</script>
<style lang="less" scoped>
@import '~@/assets/style/mixin.less';
.headline-box {
    color: @sustainabilityColor;
    font-weight: @font-weight-bold;
    font-size: @font-size-lg;
    line-height: @line-height-lg;
}
</style>
